module.exports = __webpack_public_path__ + "static/media/et.2aa49809.svg";